import React, { useState } from 'react'
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'

export default function CopySegment({ segment, close }) {
    const [name, setName] = useState(segment.name + ' Copy')

    const save = async () => {
        const response = await axios.post('/segment/clone/' + segment.id, { name })
        close(response.data.Segment)
    }

    return (<div>

        <h4 className="mar-b25">{i18n.t('subscribers:segments.copyHeader', { name: segment.name })}</h4>


        <TextInput value={name} onChange={e => setName(e.target.value)} label="New Segment Name" className="mar-b25" />

        <div className="row">
            <div className="col-xs-6">
                <Button text={i18n.t('save')} className="button-primary button-fullwidth" onClick={save} iconLeft={<Icons icon="tick" />} />
            </div>
            <div className="col-xs-6">
                <Button text={i18n.t('cancel')} className="button-fullwidth" onClick={() => close()} iconLeft={<Icons icon="cross" />} />
            </div>

        </div>
    </div>)
}